<!-- 对公打款-申请记录-页面 -->
<template>
    <div class="wrap">
        <h3>对公打款申请记录</h3>
        <div :class="classNames + '_con'">
            <div :class="classNames + '_con_table'">
                <el-table :data="tableData.list" :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }">
                    <div slot="empty">
                        <img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 80%; padding: 115px 0" />
                    </div>
                    <el-table-column :label="item.label" :prop="item.prop" :width="item.width" v-for="(item, index) in headerList" :type="item.prop" :key="index" v-bind="item.bindObj || {}">
                        <template slot-scope="scope">
                            <div v-if="item.prop == 'my_pingzheng'">
                                <a v-if="scope.row.payment_invoice" :href="scope.row.payment_invoice" target="_blank" class="blue-pointer my-a-mark">
                                    点击查看
                                </a>
                            </div>
                            <div v-else :class="[showTextOverHide(item)]">
                                <!-- {{ scope.row[item.prop] ? scope.row[item.prop] : "--" }} -->
                                {{ scope.row[item.prop] }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" :width="100">
                        <template slot-scope="scope">
                            <div>
                                <span @click="operateFn(1, scope.row)" class="blue-pointer">查看账单</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <Pagination @change="changePage" :total="tableData.total" ref="pagination" v-model="searchObj.page" v-if="tableData.total > 0"></Pagination>
        </div>
        <el-dialog title="查看账单" :visible.sync="seeBillPopObj.showPop" width="1000px">
            <div class="see-bill-pop-box">
                <div class="title-box">
                    <div class="left">
                        <span class="title">*账单明细</span>
                        <span class="tip">注意：账单明细只结算分到豆包平台商户的订单收益</span>
                    </div>
                    <div @click="exportBtnFn" class="right blue-pointer">
                        导出结算订单明细
                    </div>
                </div>
                <billDetailTable ref="billDetailTableRef" :tableData="paymentDetailData"></billDetailTable>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { applyPaymentHistory_headerList } from './data.js'
import billDetailTable from './components/billDetailTable.vue'
import { exportAboutMixin } from '@/components/mixin/mixin.js'
import { mapActions } from 'vuex'
export default {
    components: {
        billDetailTable
    },
    mixins: [ exportAboutMixin ],
    data() {
        return {
            classNames: "applyPaymentHistory",
            noDataName: "empty",
            headerList: applyPaymentHistory_headerList,
            searchObj: {
                page: 1,
                page_size: 10,
            },
            tableData: {
                list: [],
                total: 0
            }, // table数据
            seeBillPopObj: { // 查看账单弹窗
                showPop: false
            },
            paymentDetailData: { // 账单明细数据
                my_list: [],
                my_total_money: '--',
                cp_id: '' // 导出需要使用的id
            } 
        }
    },
    created(){
        this.getTableData()
    },
    methods: {
        ...mapActions('toPublicPayment',['getPaymentApplyListAPI']),
        // 点击 导出结算订单明细
        exportBtnFn(){ 
            this.exportExcel(9, {
                cp_id: this.paymentDetailData.cp_id
            })
        },
        // 操作按钮
        operateFn(type, item){
            let { channel_data,id } = item
            if(type==1){ // 查看账单
                let my_list = []
                for(let k in channel_data.list){
                    my_list.push(channel_data.list[k])
                }
                this.paymentDetailData = { 
                    my_list, 
                    my_total_money: channel_data.total_payment || '0.00',
                    cp_id: id
                }
                this.seeBillPopObj.showPop = true
            }
        },
        // 添加table cell 文字溢出隐藏类名
        showTextOverHide(item){
            return item.bindObj && item.bindObj['show-overflow-tooltip'] ? 'over-hide-text' : ''
        },
        changePage(pageNum){
            this.searchObj.page = pageNum;
            this.getTableData();
        },
        // 获取表格数据
        async getTableData(flag){
            if (flag) {
                this.searchObj.page = 1;
            }
            let res = await this.getPaymentApplyListAPI(this.searchObj)
            // console.log('getTableData-res:',res)
            this.tableData.list = res.data || []
            this.tableData.total = res.count || 0
        }
    }
}
</script>

<style lang="less" scoped>
@classNames: applyPaymentHistory;
.@{classNames}_con {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 0px 14px 18px;
    .@{classNames}_con_table{
      margin-top: 12px;
    }
    .@{classNames}_nickname {
      display: flex;
      align-items: center;
      img {
        width: 80px;
        height: 60px;
        margin-right: 10px;
        object-fit: cover;
      }
    }
}
.see-bill-pop-box{
    .title-box{
        display: flex;
        justify-content: space-between;
        .left{
            margin-bottom: 10px;
            .title{ 
                font-size: 16px;
                color: #333;
                font-weight: 700;
            }
            .tip{
                color: red;
                margin-left: 10px;
            }
        }
    }
}
.blue-pointer{
  cursor: pointer;
  color: #1989fa;
  font-size: 14px;
}
.over-hide-text{
    width: 99%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.my-a-mark{
    text-decoration: none;
}
</style>